import * as React from 'react';

import { useFinancialAccounts } from '../../../hooks/queries/useFinancialAccounts';
import { isCreditCardAccount, isDepositoryAccount } from '../../../utils/accounts';
import Entity from '../../entity';

import { TransactionFilterDropdown, type IFilterOption } from './TransactionFilterDropdown';

interface IAccountFilterDropdownProps {
  selectedIds: string[];
  onSelect: (ids: string[]) => void;
}

export const AccountFilterDropdown = ({ selectedIds, onSelect }: IAccountFilterDropdownProps) => {
  const { financialAccounts, loading } = useFinancialAccounts();

  const accountOptions = React.useMemo<IFilterOption[]>(() => {
    const filteredAccounts = financialAccounts.filter(
      (account) => isDepositoryAccount(account) || isCreditCardAccount(account)
    );

    return filteredAccounts.map((account) => ({
      id: account.id,
      label: account.name,
      sortKey: `${account.bank?.name ?? ''}|${account.name}`,
      description: (
        <span className="text-quaternary">
          {account.mask ? `••${account.mask}` : undefined}
          {account.bank?.name && <span>|</span>}
          {account.bank?.name && <span>{account.bank.name}</span>}
        </span>
      ),
      avatar: <Entity.Avatar size="md" entity={account} />,
      keywords: [account.name, account.mask, account.bank?.name].filter(Boolean),
    }));
  }, [financialAccounts]);

  if (accountOptions.length === 0) {
    return null;
  }

  return (
    <TransactionFilterDropdown
      label="Account"
      options={accountOptions}
      selectedIds={selectedIds}
      onSelect={onSelect}
      isLoading={loading}
      hideSearch
      hideSelectAll
    />
  );
};
